export const GRID_DEFAULT_HEIGHT = 514;

export const KEY_INDICATORS_DEFAULT_HEIGHT = 444;
